import { useEffect, useState } from "react";

import AccountInfo from "./components/AccountInfo";
// import BalanceArea from "./components/BalanceArea";
import Header from "./components/Header";
import MenuList from "./components/MenuList";
import { useGetNowTimezone, useGetUserInfo } from "./hooks/personal.hook";

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

import { envChangeType } from "../../plugins/utils";
import styles from "./style.module.scss";

dayjs.extend(utc);
dayjs.extend(timezone);

let currentTimeZone = "America/New_York";
dayjs.tz.setDefault(currentTimeZone);

function Personal() {
  const [currentDate, setCurrentDate] = useState("");
  const getUserInfo = useGetUserInfo({});
  const getTimezone = useGetNowTimezone({});
  useEffect(() => {
    // console.log("getTimezone", getTimezone.data);
    if (getTimezone.data?.timezone) {
      let dateInterval = 0;

      dateInterval = setInterval(() => {
        setCurrentDate(dayjs().tz(getTimezone.data?.timezone).format("YYYY-MM-DD HH:mm:ss"));
      }, 1000);

      return () => {
        clearInterval(dateInterval);
      };
    }
  }, [getTimezone.data]);

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url('/images/personal/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/bg.png'),url('/images/personal/bg.png')`,
      }}
    >
      <Header currentDate={currentDate} />
      <AccountInfo userData={getUserInfo.data} isLoading={getUserInfo.isLoading} />
      <MenuList />
    </div>
  );
}

export default Personal;
